(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelectorAll('.header__mega-products').forEach((productsWrap) => {
    const productItems = productsWrap.querySelectorAll('[data-product-panel]');
    const productPanels = productsWrap.querySelectorAll('.header-product-info');
    if (!productItems.length || !productPanels.length) return;

    if (productsWrap.querySelector('.header-collection-link-item')) {
      productItems.forEach((item) => item.classList.remove('is-active'));
      productPanels.forEach((panel) => panel.classList.remove('is-active'));
    }

    const setActivePanel = (panelId) => {
      productItems.forEach((item) => {
        item.classList.toggle('is-active', item.getAttribute('data-product-panel') === panelId);
      });
      productPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === panelId);
      });
    };

    productItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        setActivePanel(item.getAttribute('data-product-panel'));
      });
      item.addEventListener('focusin', () => {
        setActivePanel(item.getAttribute('data-product-panel'));
      });
    });
  });

  const stickyHeaderEl = document.querySelector('sticky-header');
  const headerCartTotalEls = document.querySelectorAll('[data-header-cart-total]');
  const headerMoneyFormat = stickyHeaderEl?.dataset?.headerMoneyFormat || '';
  const headerCurrency = stickyHeaderEl?.dataset?.headerCurrency || 'GBP';
  let headerCartRefreshTimer;

  const formatHeaderCartTotal = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && headerMoneyFormat) {
      return window.Shopify.formatMoney(cents, headerMoneyFormat);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: headerCurrency,
    }).format(cents / 100);
  };

  const refreshHeaderCartTotal = () => {
    if (!headerCartTotalEls.length) return;

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to fetch cart total');
        return response.json();
      })
      .then((cartData) => {
        const formatted = formatHeaderCartTotal(cartData.total_price || 0);
        headerCartTotalEls.forEach((el) => {
          el.textContent = formatted;
        });
      })
      .catch(() => {
        // Keep existing total if cart fetch fails.
      });
  };

  const scheduleHeaderCartRefresh = () => {
    window.clearTimeout(headerCartRefreshTimer);
    headerCartRefreshTimer = window.setTimeout(refreshHeaderCartTotal, 700);
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('button[name="add"], .product-form__submit[name="add"], [data-add-to-cart]');
    if (!addButton) return;
    scheduleHeaderCartRefresh();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    scheduleHeaderCartRefresh();
  });

  } catch(e) { console.error(e); }
})();
})();
